/**
 * Program: Show/Hide according to authority
 * Author: SDL
 * Description: Show/Hide according to authority
 */

/* eslint-disable no-unused-vars */
import SDLUtil from '@/utils/SDLUtil';

export default {
  bind(el, binding, vnode) {
    // permission list of page
    const { menuUserAuthList } = vnode.context.$route.meta;

    const userInfo = SDLUtil.getLoginedUserInfo();
    if (!userInfo.systemAdminUser) {
      // If it is not an administrator
      if (typeof binding.value === 'string') {
        if (!menuUserAuthList.includes(binding.value.toUpperCase())) {
          el.style.display = 'none';
        }
      } else {
        const perms = binding.value;
        let authflag = false;
        Object.keys(perms).forEach(i => {
          if (menuUserAuthList.includes(perms[i].toUpperCase())) {
            authflag = true;
          }
        });
        if (!authflag) {
          el.style.display = 'none';
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/directives/authorization.js